import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-ng-country-select',
  template: `<label>Phone Number <span> *</span></label>    
    <ng-select  [items]="to.options"
      class="customSelect"
      [bindValue]="valueProp"
      [multiple]="to.multiple"
      [virtualScroll]="true"
      [loading]="false"
      [placeholder]="to.placeholder"
      [formControl]="formControl"
      [searchFn]="customSearchFn"
      [formlyAttributes]="field">
      <div>
      <ng-template ng-label-tmp let-item="item">
      {{ item.id }}
  </ng-template>
      <ng-template ng-option-tmp let-item="item">
      {{ item.text }}
  </ng-template>
  </div>
    </ng-select>
  `,
})
export class FormlyFieldCountryCode extends FieldType {
  get labelProp(): string { 
    return this.to.labelProp || 'text' }
  get valueProp(): string { 
    return this.to.valueProp || 'id' }
    selectedSimpleItem = []

  customSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.text.toLocaleLowerCase().indexOf(term) > -1;
   }
}